function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgStarOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1a.5.5 0 0 1 .448.279l1.94 3.932 4.34.631a.5.5 0 0 1 .278.853l-3.14 3.061.74 4.323a.5.5 0 0 1-.725.527l-3.882-2.041-3.882 2.04a.5.5 0 0 1-.725-.526l.741-4.323-3.14-3.061a.5.5 0 0 1 .277-.853l4.34-.63 1.94-3.933A.5.5 0 0 1 8 1Zm0 1.63L6.39 5.89a.5.5 0 0 1-.376.273l-3.598.523L5.02 9.224a.5.5 0 0 1 .143.442L4.55 13.25l3.218-1.692a.5.5 0 0 1 .465 0l3.218 1.692-.615-3.583a.5.5 0 0 1 .144-.442l2.603-2.538-3.597-.523a.5.5 0 0 1-.377-.273L8 2.63Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgStarOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgStarOutlinedIcon);
export default Memo;